import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";


const firebaseConfig = {
    apiKey: "AIzaSyBtV7qC1_RXadyQ1d_3b0LMzhdskFnLRTQ",
    authDomain: "gef-contact.firebaseapp.com",
    databaseURL: "https://gef-contact-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "gef-contact",
    storageBucket: "gef-contact.firebasestorage.app",
    messagingSenderId: "1062893117538",
    appId: "1:1062893117538:web:bb20528bc816c22521f13b",
    measurementId: "G-Q61M06SCWR"
  };

  const app = initializeApp(firebaseConfig);
  export const auth = getAuth(app);
  export const database = getDatabase(app);
